<div class="app-shell">
  <aside class="sidebar" [class.open]="sidebarOpen()">
    <app-static-sidemenu [activeKey]="activeKey()" />
  </aside>

  <div class="sidebar-overlay" [class.open]="sidebarOpen()" (click)="closeSidebar()"></div>

  <div class="main-column">
    <header class="topbar">
      <app-navbar [activeKey]="activeKey()" (toggleSidebar)="toggleSidebar()" />
    </header>
    <div class="static-banner">
      <span class="static-banner-dot"></span>
      Static reference &mdash; frozen, non-API-integrated design.
      <a [routerLink]="['/dashboard']">Go to live app &rarr;</a>
    </div>
    <main class="content">
      <router-outlet />
    </main>
  </div>
</div>
